<script setup>
import { defineProps, onMounted, ref } from 'vue';
import Siema from 'siema';

const props = defineProps({
	name: String,
	innerNav: Boolean,
	perPage: Number | Object,
});

const carousel = ref(null);

onMounted(() => {
	carousel.value = new Siema({
		selector: `#${props.name}`,
		perPage: props.perPage ?? 3,
		loop: true,
	});

	// autoplay
	setInterval(() => carousel.value.next(), 3000);
});

</script>

<template>
	<div class="carousel-wrap">
		<div class="carousel-wrap__carousel">
			<div :id="props.name">
				<slot></slot>
			</div>
		</div>
		<nav class="carousel-wrap__nav" :class="{'inner': props.innerNav}">
			<button @click='carousel.prev()' aria-label="Previous image">&lt;</button>
			<button @click='carousel.next()' aria-label="Next image">&gt;</button>
		</nav>
	</div>
</template>